import { firebase } from '@app/config/fire-conf';
import { Seat } from '@app/types/seat';
import { Showtime, TimeSeconds } from '@app/types';

export enum CinemaIds {
  c1,
  c2,
  c3,
}

export type Cinema = {
  id: string;
  label: string;
  description: string;
  numberOfSeats: number;
  features: string[];
  ticketPrices: {
    adult: number;
    child: number;
  };
  seatsPerRow: number;
  seats: Seat[];
  showtimes: Showtime[];
  lastUpdatedAt: firebase.firestore.Timestamp;
};

export type CinemaSingle = Omit<Cinema, 'lastUpdatedAt'> & {
  lastUpdatedAt: TimeSeconds;
};
